import React from 'react';
import MapDrawingBoard from './MapDrawingBoard';
import OrthoToolbox from './OrthoToolbox';
import DashboardToolErrorBoundary from './DashboardToolErrorBoundary';
import {
  shouldMountOrthoToolbox,
  buildOrthoToolboxPermissionProps
} from '../utils/dashboard/dashboardWorkspaceProps';

/**
 * 地图左侧工具：叠加工具 + 画板。
 * 桌面/移动共用，避免双分支条件漂移；错误边界隔离，互不拖垮。
 */
export default function DashboardMapSideTools({
  commandFeatures = {},
  mapLoadingState,
  mapRef,
  members,
  drawingToolsActiveRef,
  stopEarthAnimation,
  loadRescueData,
  isMobile = false,
  onRequestMapSelectSpace
}) {
  const orthoPerms = buildOrthoToolboxPermissionProps(commandFeatures);
  const showOrtho = shouldMountOrthoToolbox(commandFeatures);
  const showDraw = commandFeatures.drawBoard !== false;
  const mapReady = mapLoadingState === 'loaded';

  const orthoFallback = (
    <button
      type="button"
      className="zhxt-ortho-tab"
      title="地图叠加工具异常，请刷新页面"
      style={{ pointerEvents: 'auto' }}
      onClick={() => window.location.reload()}
    >
      <span className="zhxt-ortho-tab-label">叠加</span>
    </button>
  );

  const drawFallback = (
    <button
      type="button"
      className="zhxt-draw-tab"
      title="画板异常，请刷新页面"
      style={{ pointerEvents: 'auto', position: 'absolute', left: 0, top: '42%' }}
      onClick={() => window.location.reload()}
    >
      <span className="zhxt-draw-tab-label">画板</span>
    </button>
  );

  return (
    <>
      {showOrtho && (
        <DashboardToolErrorBoundary name="OrthoToolbox" fallback={orthoFallback}>
          <OrthoToolbox
            mapReady={mapReady}
            getMap={() => mapRef.current}
            members={members}
            {...orthoPerms}
            drawingToolsActiveRef={drawingToolsActiveRef}
            onStartInteract={() => stopEarthAnimation()}
            isMobile={isMobile}
            onRequestMapSelectSpace={onRequestMapSelectSpace}
          />
        </DashboardToolErrorBoundary>
      )}
      {showDraw && (
        <DashboardToolErrorBoundary name="MapDrawingBoard" fallback={drawFallback}>
          <MapDrawingBoard
            mapReady={mapReady}
            getMap={() => mapRef.current}
            members={members}
            allowPush={commandFeatures.boardPush !== false}
            allowExport={commandFeatures.exportTrack !== false}
            onActiveChange={(active) => { drawingToolsActiveRef.current = !!active; }}
            onStartInteract={() => stopEarthAnimation()}
            onTrackPushed={() => loadRescueData()}
          />
        </DashboardToolErrorBoundary>
      )}
    </>
  );
}
